/**
 * 微信小程序扫一扫封装
 * @param options 可选配置
 * @returns Promise<string> 扫码结果字符串
 */
import { showToast } from 'vant'
export const scanQRCode = (options?: {
  scanType?: ('qrCode' | 'barCode')[];
  needResult?: number;
  timeout?: number;
}): Promise<string> => {
  // 默认配置
  const defaultOptions = {
    scanType: ['qrCode'] as ('qrCode' | 'barCode')[],
    needResult: 1,
    timeout: 30000,
    ...options,
  };

  return new Promise((resolve, reject) => {
    // 检查环境是否支持
    if (!window.wx?.scanQRCode) {
      showToast({
        message: '当前环境不支持微信小程序扫一扫功能',
        duration: 3000,
        type: 'fail'
      });
      reject(new Error('当前环境不支持微信小程序扫一扫功能'));
      return;
    }

    // 调用扫一扫 API
    window.wx.scanQRCode({
      ...defaultOptions,
      success: (res) => {
        console.log('扫码成功：', res.resultStr);
        resolve(res.resultStr);
      },
      fail: (err) => {
        console.error('扫码失败：', err);
        reject(err);
      },
      complete: () => {
        console.log('扫码流程结束');
      },
    });
  });
};